import React from "react";
import {
  filterCurveDataToRange,
  getShortName,
  hasProperty,
  processSymbols,
  segmentsIntoSingleCurve,
  splitCurveIntoSegmentsByEdges,
  createDataPayloadForModels,
  generateWarningObject,
  convertDataFromUnitsToUnits,
  getQuantityXUnitFromModels,
} from "../../../utils/helpers";
import units from "../../../utils/units";
// import { processFileWithOptions } from "../../leftSide/Files/fileProcessing/processingLogic";
import { deepCopy, getModelsByIds, getModelById } from "../../leftSide/Models/modelLogic";
import { createModelFitPayloadParams } from "../../middle/graphLogic";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HtmlTooltip from "../../commonComponents/HtmlTooltip";

export function createFitModelEntry(
  model,
  depth,
  indexArray,
  handleModelClick,
  selectedModelQuantitySet
) {
  if (model.outputs.length > 1) {
    return (
      <div
        key={indexArray + "|" + model.FE_ID}
        style={{ marginLeft: `${depth * 8}px` }}
      >
        <Accordion className="modelOutputAccordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className={`accordionSummary ${
              selectedModelQuantitySet &&
              selectedModelQuantitySet.modelId === model.FE_ID
                ? "selected"
                : ""
            }`}
          >
            {/* <div>
            {model.displayName}
            </div> */}
            <Typography>{model.displayName}</Typography>
          </AccordionSummary>
          <AccordionDetails className="accordionDetails">
            <div className="modelCurveAccordion">
              {model.outputs.map((output, index) => {
                return (
                  <div key={output.speqqle_id}>
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <div className="outputTooltip">
                            {processSymbols(output.description)}
                          </div>
                        </React.Fragment>
                      }
                    >
                      <div
                        className={`outputItem ${
                          index === model.outputs.length - 1 ? "lastItem" : ""
                        } ${
                          selectedModelQuantitySet &&
                          selectedModelQuantitySet.modelId === model.FE_ID &&
                          selectedModelQuantitySet.quantity ===
                            output.speqqle_id
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => {
                          handleModelClick(
                            model.FE_ID,
                            getShortName(model.displayName),
                            output.name,
                            output.speqqle_id
                          );
                        }}
                      >
                        {processSymbols(output.name)}
                      </div>
                    </HtmlTooltip>
                  </div>
                );
              })}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  } else if (model.outputs.length === 1) {
    const output = model.outputs[0];
    return (
      <div
        key={indexArray + "|" + model.FE_ID}
        style={{ marginLeft: `${depth * 8}px` }}
      >
        <div
          className={`singleModelOutput ${
            selectedModelQuantitySet &&
            selectedModelQuantitySet.modelId === model.FE_ID &&
            selectedModelQuantitySet.quantity === output.speqqle_id
              ? "selected"
              : ""
          }`}
        >
          <HtmlTooltip
            title={
              <React.Fragment>
                <div
                  className="outputTooltip"
                  style={{ fontSize: "1.2em", textDecoration: "underline" }}
                >
                  {processSymbols(output.name)}
                </div>
                <div className="outputTooltip">
                  {processSymbols(output.description)}
                </div>
              </React.Fragment>
            }
          >
            <div
              className={`outputItem lastItem`}
              onClick={() => {
                handleModelClick(
                  model.FE_ID,
                  getShortName(model.displayName),
                  output.name,
                  output.speqqle_id
                );
              }}
              id={`list-item-${model.displayName}`}
            >
              {/* {processSymbols(output.name)} */}
              {model.displayName}
            </div>
          </HtmlTooltip>
        </div>
      </div>
    );
  }
}

export function performChi2Message(
  chi2Terms,
  models,
  uploadedFiles,
  sendJsonMessage,
  user,
  recordedErrorLog,
  chi2ReqAllowed,
  setChi2ReqAllowed,
  chi2QueRef,
  setWarnings = null,
  setNewWarningCount = null,
  limitedToast = null
) {
  try {
    if (chi2ReqAllowed) {
      let chi2TermsToUse = chi2Terms;
      if (chi2QueRef.current.length > 0) {
        for (let i = 0; i < chi2Terms.length; i++) {
          const term = chi2Terms[i];
          if (!hasProperty(term, "useFullRange")) {
            term.useFullRange = true;
            term.rangeMin = "";
            term.rangeMax = "";
          }

          chi2QueRef.current = {
            ...chi2QueRef.current,
            [`${term.id}`]: term,
          };
        }
        chi2TermsToUse = Object.values(chi2QueRef.current);
      }
      const payload = generateChi2Payload(
        uploadedFiles,
        models,
        chi2TermsToUse,
        user
        // recordedErrorLog
      );

      if (payload === null) {
        if (setWarnings && setNewWarningCount) {
          generateWarningObject(
            "The same data file can not be part of a model and a chi2 term at the same time, or coupled with different model outputs.",
            2,
            setWarnings,
            setNewWarningCount
          );
          limitedToast(
            "The same data file can not be part of a model and a chi2 term at the same time, or coupled with different model outputs."
          );
        }
        return;
      }
      chi2QueRef.current = {};

      sendJsonMessage(payload, { type: "chi2-message" });

      setChi2ReqAllowed(false);
    } else {
      for (let i = 0; i < chi2Terms.length; i++) {
        const term = chi2Terms[i];
        if (!hasProperty(term, "useFullRange")) {
          term.useFullRange = true;
          term.rangeMin = "";
          term.rangeMax = "";
        }
        chi2QueRef.current = {
          ...chi2QueRef.current,
          [`${term.id}`]: term,
        };
      }
    }
  } catch (error) {
    recordedErrorLog("There was an error performing chi2 message", error);
  }
}

function generateChi2Payload(
  uploadedFiles,
  models,
  terms,
  user
  // recordedErrorLog
) {
  const termsModels = [...new Set(terms.map((term) => term.modelId))];

  const modelsForPayload = getModelsByIds(termsModels, deepCopy(models));

  let modelDataPayloadWithFiles = createModelFitPayloadParams(modelsForPayload);
  let modelDataPayload = modelDataPayloadWithFiles.sendModelData;
  let addedDataFilesIds = modelDataPayloadWithFiles.addedDataFilesIds;
  let fileDataFromModelPayload = [];
  if (
    uploadedFiles &&
    uploadedFiles.length > 0 &&
    addedDataFilesIds.length > 0
  ) {
    fileDataFromModelPayload = createDataPayloadForModels(
      addedDataFilesIds,
      uploadedFiles
    );
  }

  let fileDataPayload = [];

  for (let i = 0; i < terms.length; i++) {
    const termFileId = terms[i].fileId;
    const termModel = getModelById(terms[i].modelId, deepCopy(models));
    const termQuantity = terms[i].quantity;
    let termUnit = getQuantityXUnitFromModels([termModel], terms[i].modelId, termQuantity);

    const prevData = fileDataPayload.find((fileData) => fileData.dataid === termFileId)

    if (prevData) {
      if (prevData.unit === termUnit.name) {
        continue;
      }
      else {
        return null;
      }
    }

    const file = uploadedFiles.find((file) => file.ID == termFileId);
    let data = file.dataPoints;

    data = filterCurveDataToRange(data, file.dataRangeMin, file.dataRangeMax);

    data = segmentsIntoSingleCurve(
      splitCurveIntoSegmentsByEdges(data, file.edges)
    );

    const convertedData = convertDataFromUnitsToUnits(units[0], termUnit, data, true);

    fileDataPayload.push({ dataid: termFileId, data: convertedData, unit: termUnit.name });
  }

  let termsWithIDs = terms.map((term) => {
    if (!hasProperty(term, "useFullRange") || term.useFullRange) {
      return {
        modelid: term.modelId,
        dataid: term.fileId,
        quantity: term.quantity,
        ranges: [{ weight: term.weight }],
      };
    } else {
      let range = { weight: term.weight };
      if (term.rangeMin !== "" && !isNaN(parseFloat(term.rangeMin))) {
        range.xmin = parseFloat(term.rangeMin);
      }
      if (term.rangeMax !== "" && !isNaN(parseFloat(term.rangeMax))) {
        range.xmax = parseFloat(term.rangeMax);
      }
      return {
        modelid: term.modelId,
        dataid: term.fileId,
        quantity: term.quantity,
        ranges: [range],
      };
    }
  });

  if (fileDataFromModelPayload.length > 0) {
    if (
      fileDataFromModelPayload.some((file) =>
        fileDataPayload.some(
          (fileInPayload) => fileInPayload.dataid === file.dataid
        )
      )
    ) {
      return null;
    }
    fileDataPayload = [...fileDataPayload, ...fileDataFromModelPayload];
  }
  let payload = {
    User: user.id,
    Model: {
      SendModel: modelDataPayload,
    },
    Data: {
      SendData: fileDataPayload,
    },
    Fit: {
      GetChi2: termsWithIDs,
    },
  };
  return payload;
}

export function getTotalChi2Terms(chi2Terms, selectedChi2Terms) {
  let totalChi2 = 0;
  let updated = false;

  for (let i = 0; i < chi2Terms.length; i++) {
    const term = chi2Terms[i];

    if (
      term.chi2 !== null &&
      term.weight !== 0 &&
      term.weight !== "" &&
      selectedChi2Terms.some((id) => id === term.id)
    ) {
      updated = true;
      totalChi2 += parseFloat(term.chi2 * term.weight);
    }
  }

  if (updated) {
    return totalChi2;
  } else {
    return "N/A";
  }
}

export function getTotalActiveParams(chi2Terms, selectedChi2Terms) {
  let totalAP = 0;
  let updated = false;

  for (let i = 0; i < chi2Terms.length; i++) {
    const term = chi2Terms[i];

    if (
      term.chi2 !== null &&
      term.weight !== 0 &&
      term.weight !== "" &&
      selectedChi2Terms.some((id) => id === term.id)
    ) {
      updated = true;
      if (term.weight !== 0) {
        totalAP += parseInt(term.activeParams);
      }
    }
  }

  if (updated) {
    return totalAP;
  } else {
    return "N/A";
  }
}

export function updatedChi2(newTerms, currentTerms) {
  let updatedTerms = deepCopy(currentTerms);
  updatedTerms = updatedTerms.map((term) => {
    let selectedTerm = undefined;
    const foundTermUpdates = newTerms.filter(
      (newTerm) =>
        term.modelId === newTerm.ModelID &&
        term.fileId === newTerm.DataID &&
        term.quantity === newTerm.Quantity
    );
    if (foundTermUpdates.length === 0) {
      return term;
    }
    if (!hasProperty(term, "useFullRange") || term.useFullRange) {
      selectedTerm = foundTermUpdates.find(
        (newTerm) =>
          !hasProperty(newTerm, "xmin") && !hasProperty(newTerm, "xmax")
      );
      if (selectedTerm === undefined) {
        return term;
      }
    } else {
      let preselectedTerm = [];
      if (
        hasProperty(term, "rangeMin") &&
        term.rangeMin !== "" &&
        !isNaN(parseFloat(term.rangeMin))
      ) {
        preselectedTerm = foundTermUpdates.filter(
          (newTerm) =>
            hasProperty(newTerm, "xmin") &&
            newTerm.xmin === parseFloat(term.rangeMin)
        );
        if (preselectedTerm.length === 0) {
          preselectedTerm = foundTermUpdates.filter(
            (newTerm) =>
              hasProperty(newTerm, "xmin") &&
              newTerm.xmin > parseFloat(term.rangeMin) * 0.999999 &&
              newTerm.xmin < parseFloat(term.rangeMin) * 1.000001
          );
        }
      } else {
        preselectedTerm = foundTermUpdates.filter(
          (newTerm) => !hasProperty(newTerm, "xmin")
        );
      }
      if (preselectedTerm.length > 0) {
        if (
          hasProperty(term, "rangeMax") &&
          term.rangeMax !== "" &&
          !isNaN(parseFloat(term.rangeMax))
        ) {
          selectedTerm = preselectedTerm.find(
            (newTerm) =>
              hasProperty(newTerm, "xmax") &&
              newTerm.xmax === parseFloat(term.rangeMax)
          );
          if (selectedTerm === undefined) {
            selectedTerm = preselectedTerm.find(
              (newTerm) =>
                hasProperty(newTerm, "xmax") &&
                newTerm.xmax > parseFloat(term.rangeMax) * 0.999999 &&
                newTerm.xmax < parseFloat(term.rangeMax) * 1.000001
            );
          }
        } else {
          selectedTerm = preselectedTerm.find(
            (newTerm) => !hasProperty(newTerm, "xmax")
          );
        }
      }
    }
    if (selectedTerm === undefined) {
      return term;
    } else {
      if (hasProperty(term, "needsUpdate")) {
        delete term.needsUpdate;
      }
      return {
        ...term,
        chi2: selectedTerm.value,
        activeParams: selectedTerm.nActiveParameters,
        nDataPoints: selectedTerm.nDataPoints,
      };
    }
  });
  return updatedTerms;
}

export function getListOfTermsToUpdate(terms, updatedModelIDs) {
  let termsToUpdate = [];

  for (let i = 0; i < terms.length; i++) {
    const term = terms[i];
    for (let j = 0; j < updatedModelIDs.length; j++) {
      const modelId = updatedModelIDs[j];
      if (term.modelId === modelId) {
        termsToUpdate.push(term);
      }
    }
  }

  return termsToUpdate;
}
